import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FeedDocumentComponent } from 'src/app/modules/feeds/pages/feed-document/feed-document.component';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { BasicInfoTabService } from '../../services/basic-info-tab.service';
@Component({
  selector: 'app-job-profile-post-preview',
  templateUrl: './job-profile-post-preview.component.html',
  styleUrls: ['./job-profile-post-preview.component.scss']
})
export class JobProfilePostPreviewComponent implements OnInit {
  savedDocuments: any = {
    resume: [],
    cover_letter: [],
    certificate: []
  };
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private _dialog: MatDialog, private dialogRef: MatDialogRef<JobProfilePostPreviewComponent>, private basicInfoTabService: BasicInfoTabService) { }

  showMap = false;
  isModalOpen: boolean = false;
  previewLoader = false;
  showFull = false;

  ngOnInit(): void {

    this.previewLoader = true;

    if (this.data.postPreview) {
      this.previewLoader = false;
    }


    if (this.data?.id) {
      this.loadTalentDetailsPreview(this.data.id);
    }
  }

  private loadTalentDetailsPreview(id: string): void {
    this.basicInfoTabService.getTalentPreview(id).subscribe({
      next: (res: any[]) => {
        this.previewLoader = false;
        if (res?.length) {
          this.data = res[0];
        }
      },
      error: () => (this.previewLoader = false)
    });
  }

  openMap(): void {
    const location = this.data.location;

    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: location }, (results, status) => {
      if (status === 'OK' && results && results.length > 0) {
        const latLng = results[0].geometry.location;

        this.showMap = true;

        setTimeout(() => {
          const mapElement = document.getElementById('map');
          if (mapElement) {
            const map = new google.maps.Map(mapElement, {
              center: latLng,
              zoom: 4,
              mapTypeId: 'roadmap'
            });

            new google.maps.Marker({
              position: latLng,
              map,
              title: location
            });
          }
        }, 100);
      }
    });
  }
  onOutsideClick(event: MouseEvent) {
    this.showMap = false;
    this.isModalOpen = false;
  }

  // this is all data  show in carousel
  // viewDocument(index: number, documents: any[]): void {
  //   if (!Array.isArray(documents) || !documents.length) { return; }

  //   this._dialog.open(DocumentViewerComponent, {
  //     width: '80%',
  //     panelClass: ['custom-modal'],
  //     data: {
  //       documents,
  //       initialIndex: index
  //     }
  //   });
  // }


  
  viewDocument(doc) {
    if (doc) {
      this._dialog.open(FeedDocumentComponent, {
        width: '40%',
        panelClass: ['custom-modal'],
        data: doc,
      });
    }
  }



  feeddocumentView(doc) {

    if (doc) {

      this._dialog.open(FeedDocumentComponent, {
        width: '40%',
        panelClass: ['custom-modal'],
        data: doc
      })
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

    // description
   toggleDescription() {
    this.showFull = !this.showFull;
  }

  
    showMoreDates = false;
  showMoreDays = false;

  get visibleDates() {
    return this.showMoreDates ? this.data?.availabilityDate : this.data?.availabilityDate?.slice(0, 5);
  }
 

  get visibleDays() {
    return this.showMoreDays ? this.data?.availabilityDay : this.data?.availabilityDay?.slice(0, 5);
  }


}